// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_Z78","cls2":"CiterightInline-cls2_oM1 CiterightInline-cls1_Z78"};